import React from 'react'
import { SprintPacketHydrated } from '@marketing-milk/interfaces'
import { numberToUSD } from '../../../../../util/util'
import { SurfacePalette } from '../../tokens'
import { KPIGrid } from '../../components/KPIGrid'
import { KPITile } from '../../components/KPITile'
import { SectionCard } from './SectionCard'

interface Props {
  palette: SurfacePalette
  packet: SprintPacketHydrated
}

const EMPTY = '—'

const isMissing = (n: number | null | undefined): n is null | undefined =>
  n === null || n === undefined

const formatMoney = (n: number | null | undefined) => (isMissing(n) ? EMPTY : numberToUSD(n))
const formatCount = (n: number | null | undefined) =>
  isMissing(n) ? EMPTY : new Intl.NumberFormat('en-US').format(n)

const formatBudgetVsTarget = (
  budget: number | null | undefined,
  target: number | null | undefined
) => {
  const budgetStr = isMissing(budget) ? EMPTY : numberToUSD(budget)
  const targetStr = isMissing(target) ? null : numberToUSD(target)
  if (budgetStr === EMPTY && targetStr === null) return EMPTY
  if (targetStr === null) return budgetStr
  return `${budgetStr} / ${targetStr}`
}

export const PerformanceReviewSection = ({ palette, packet }: Props) => {
  const p = packet.performance
  return (
    <SectionCard
      palette={palette}
      sectionKey="performance-review"
      title="Performance Review"
      commentAnchor={{
        type: 'section',
        id: `${packet.id}:performance-review`,
        label: 'Performance Review',
      }}
    >
      <KPIGrid>
        <KPITile
          palette={palette}
          label="Spend"
          value={formatMoney(p?.spend)}
          commentAnchor={{ type: 'performance-metric', id: `${packet.id}:spend`, label: 'Spend' }}
        />
        <KPITile
          palette={palette}
          label="Conversions"
          value={formatCount(p?.conversions)}
          commentAnchor={{
            type: 'performance-metric',
            id: `${packet.id}:conversions`,
            label: 'Conversions',
          }}
        />
        <KPITile
          palette={palette}
          label="CPA"
          value={formatMoney(p?.cpa)}
          commentAnchor={{ type: 'performance-metric', id: `${packet.id}:cpa`, label: 'CPA' }}
        />
        <KPITile
          palette={palette}
          label="Budget vs Target"
          value={formatBudgetVsTarget(p?.budget, p?.budgetTarget)}
          commentAnchor={{
            type: 'performance-metric',
            id: `${packet.id}:budget`,
            label: 'Budget vs Target',
          }}
        />
      </KPIGrid>
    </SectionCard>
  )
}
